module.exports = __webpack_public_path__ + "static/Presence-min-0335c1846d99b172c94a441eb57f0ba2.png";